import { useEffect } from 'react';

const BRAND = 'Universal Krishna Gaukul Mission (UKGM)';
const DEFAULT_DESC =
  'Universal Krishna Gaukul Mission (UKGM) — A Registered Public Charitable Trust in India. Elderly care, cow care, animal welfare, environment conservation and social welfare. 80G · 12A · CSR-1.';

/**
 * Lightweight SEO hook — sets <title> and <meta name="description"> per route
 * without pulling in react-helmet. Restores the previous values on unmount so
 * route changes cannot leave stale metadata.
 */
export function useSEO({ title, description } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const metaEl =
      document.querySelector('meta[name="description"]') ||
      (() => {
        const m = document.createElement('meta');
        m.setAttribute('name', 'description');
        document.head.appendChild(m);
        return m;
      })();
    const prevDesc = metaEl.getAttribute('content') || '';

    const fullTitle = title ? `${title} · ${BRAND}` : BRAND;
    document.title = fullTitle;
    metaEl.setAttribute('content', description || DEFAULT_DESC);

    return () => {
      document.title = prevTitle;
      metaEl.setAttribute('content', prevDesc);
    };
  }, [title, description]);
}
